import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { ReferenceStore } from 'src/app/stores/reference.store';
import { IProviderList } from '../../interfaces/provider-list';
import { FormatSettings } from '@progress/kendo-angular-dateinputs';
import moment from 'moment';
import { LiveRegionService } from 'src/app/shared/services/live-region.service';
import { Constants } from 'src/app/shared/constants/constants';
import { IReferenceData } from 'src/app/shared/interfaces/form/reference-data.model';
@Component({
  selector: 'app-encounter-filters',
  templateUrl: './encounter-filters.component.html',
  styleUrls: ['./encounter-filters.component.scss'],
  standalone: false,
})
export class EncounterFiltersComponent
  extends DialogContentBase
  implements OnInit
{
  allEncounterFiltersForm: FormGroup;
  providerList: IProviderList[];
  public format: FormatSettings = {
    displayFormat: 'MM/dd/yyyy',
    inputFormat: 'MM/dd/yyyy',
  };
  locationFilterOptions: Array<{ text: string; value: string }> = [];
  uniqueProviderNames: IProviderList[] = [];
  initialFilters: any;
  // Encounter Type / Status / Sort by moved here so the mobile funnel exposes
  // them (they are not part of the inline toolbar on mobile). Status options are
  // supplied by the parent; Sort options come from the shared constant.
  encounterStatusList: IReferenceData[] = [];
  sortDropdown: IReferenceData[] = Constants.SORT_BY_ENCOUNTER_DROPDOWN;

  constructor(
    dialogRef: DialogRef,
    public referenceStore: ReferenceStore,
    private fb: FormBuilder,
    private liveRegionService: LiveRegionService
  ) {
    super(dialogRef);
  }

  onFilter(): void {
    this.liveRegionService.announceFiltersApplied();
    this.dialog.close(this.allEncounterFiltersForm); // Pass filter data here
  }

  ngOnInit(): void {
    this.initForm();
    this.setupStudentExclusion();
    this.setupProviderExclusion();
    this.buildUniqueProviderNames();
    if (this.initialFilters) {
    this.allEncounterFiltersForm.patchValue(this.initialFilters);
  }
  }

  private buildUniqueProviderNames(): void {
    const seen = new Set<string>();
    this.uniqueProviderNames = (this.providerList || []).filter(p => {
      if (!p.providerName) {
        return false;
      }
      if (seen.has(p.providerName)) {
        return false;
      }
      seen.add(p.providerName);
      return true;
    });
  }

  private toDateOnlyString(value: any): string | null {
  if (!value) {
    return null;
  }

  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }

  const m = moment(value);
  return m.isValid() ? m.format('YYYY-MM-DD') : null;
}

  initForm(): void {
    this.allEncounterFiltersForm = this.fb.group({
      studentName: [''],
      studentId: [''],
      studentType: [null],
      dateOfBirth: [null],
      serviceType: [null],
      language: [null],
      mandateTerm: [null],
      frequency: [null],
      duration: [null],
      groupSize: [null],
      scheduledDate: [null],
      scheduledDuration: [null],
      location: [null],
      actualServiceDate: [null],
      providerName: [null],
      providerId: [''],
      providerTitle: [null],
      scheduledStartTime: [null],
      encounterType: [null],
      status: [null],
      sortBy: [null],
    });
  }

  private setupStudentExclusion(): void {
    const studentNameCtrl = this.allEncounterFiltersForm.get('studentName');
    const studentIdCtrl = this.allEncounterFiltersForm.get('studentId');

    studentNameCtrl?.valueChanges.subscribe((value: string) => {
      if (value && value.trim().length > 0) {
        studentIdCtrl?.disable({ emitEvent: false });
        studentIdCtrl?.reset('', { emitEvent: false });
      } else {
        studentIdCtrl?.enable({ emitEvent: false });
      }
    });
    studentIdCtrl?.valueChanges.subscribe((value: string) => {
      if (value && value.trim().length > 0) {
        studentNameCtrl?.disable({ emitEvent: false });
        studentNameCtrl?.reset('', { emitEvent: false });
      } else {
        studentNameCtrl?.enable({ emitEvent: false });
      }
    });
  }

  private setupProviderExclusion(): void {
    const providerNameCtrl = this.allEncounterFiltersForm.get('providerName');
    const providerIdCtrl = this.allEncounterFiltersForm.get('providerId');

    providerNameCtrl?.valueChanges.subscribe((value: any) => {
      if (value) {
        providerIdCtrl?.disable({ emitEvent: false });
        providerIdCtrl?.reset('', { emitEvent: false });
      } else {
        providerIdCtrl?.enable({ emitEvent: false });
      }
    });

    providerIdCtrl?.valueChanges.subscribe((value: string) => {
      if (value && value.trim().length > 0) {
        providerNameCtrl?.disable({ emitEvent: false });
        providerNameCtrl?.reset(null, { emitEvent: false });
      } else {
        providerNameCtrl?.enable({ emitEvent: false });
      }
    });
  }

  clearFilters(): void {
    this.allEncounterFiltersForm.reset();
    this.liveRegionService.announceFiltersCleared();
  }
}
